import React from 'react';

const Stepper = ({ currentStep, totalSteps }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="d-flex justify-content-between align-items-center position-relative mb-5" style={{ width: '80%', margin: '0 auto' }}>
      {/* Background Line */}
      <div className="position-absolute top-50 start-0 end-0" style={{ height: '2px', backgroundColor: '#e1e5eb', zIndex: 0, marginTop: '-1px', left: '17.5px', right: '17.5px' }}></div>
      
      {/* Completed Line (Green) */}
      <div 
        className="position-absolute top-50 start-0" 
        style={{ 
          height: '2px', 
          backgroundColor: '#4a6502', 
          zIndex: 0, 
          marginTop: '-1px', 
          left: '17.5px', 
          width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%`,
          transition: 'width 0.3s ease'
        }}
      ></div>

      {steps.map((step) => {
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;
        
        return (
          <div 
            key={step} 
            className="rounded-circle d-flex align-items-center justify-content-center fw-bold" 
            style={{
              width: '35px', height: '35px', zIndex: 1,
              backgroundColor: isCompleted || isActive ? '#4a6502' : '#ffffff',
              color: isCompleted || isActive ? '#ffffff' : '#8c98a4',
              border: isCompleted || isActive ? 'none' : '2px solid #e1e5eb',
              transition: 'all 0.3s ease'
            }}
          >
            {isCompleted ? <i className="fa fa-check"></i> : step}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
